<template>
  <span class="loading">
    <span v-if="!show">
      <slot />
    </span>
    <b-spinner
      v-else
      :small="small"
      :variant="$setup.theme == 'dark' ? 'primary' : 'light'"
    />
  </span>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    }
  }
};
</script>
